import React, { useState } from "react";
import Plot from "react-plotly.js";
import Dropdown from "./Dropdown";
import "../css/switch.css"
const TSA = ({ data, attributes }) => {
  // console.log("tsa attributes",attributes)

  // const getLabel = (value) => {
  //   for (let i = 0; i < attributes.length; i++) {
  //     if (attributes[i].value === value) {
  //       return attributes[i].label;
  //     }
  //   }
  // };

  const initialXAttribute = attributes[0].label;
  const [xAttribute, setXAttribute] = useState(initialXAttribute);
  // const xAxisLabel = getLabel(xAttribute);

  const initialIndex = attributes[0].label;
  const [indAttribute, setindAttribute] = useState(initialIndex);
  // const indLabel = getLabel(indAttribute);

  const xdata = [];
  for (let i = 0; i < data.length; i++) {
    xdata[i] = data[i][indAttribute];
  }

  const ydata = [];
  for (let i = 0; i < data.length; i++) {
    ydata[i] = data[i][xAttribute];
  }

  var tsadata = [
    {
      x: xdata,
      y: ydata,
      type: "scatter",
    },
  ];

  return (
    <>
      <div className="col-3">
        <h4>Select the columns:</h4>
        <Dropdown
          options={attributes}
          id="attr"
          selectedValue={xAttribute}
          onSelectedValueChange={setXAttribute}
        />

        <h4 className='my-5'>Select the index column:</h4>
        <Dropdown
          options={attributes}
          id="indattr"
          selectedValue={indAttribute}
          onSelectedValueChange={setindAttribute}
        />
        <p>
          <i>**Note: for Time Series, Select Index as Date or Time.</i>
        </p>
        <div className="my-5 mx-5">
          <label>Mean:</label>&nbsp;&nbsp;&nbsp;&nbsp;
          <label class="switch">
            <input type="checkbox" />
            <span class="slider round"></span>
          </label>
        </div>
        <div className="my-5 mx-5">
          <label>Standard Deviation:</label>&nbsp;&nbsp;&nbsp;&nbsp;
          <label class="switch">
            <input type="checkbox" />
            <span class="slider round"></span>
          </label>
        </div>
      </div>
      <div className="col-8">
        <Plot data={tsadata} />
      </div>
    </>
  );
};

export default TSA;
